import React, { useState } from 'react';
import { researchToolsApi } from '../api';
import type { SurveyDetail } from '../types';
import { SurveyHubHero } from './SurveyHubHero';
import '../survey-hub.css';

interface Props {
  survey: SurveyDetail;
  onOpenGuestAnonymous: () => void;
  onOpenGuestVerified: () => void;
  onOpenDashboard: () => void;
  onBack: () => void;
}

/** Publish + guest link — template publish(). */
export const SurveyPublishView: React.FC<Props> = ({
  survey,
  onOpenGuestAnonymous,
  onOpenGuestVerified,
  onOpenDashboard,
  onBack,
}) => {
  const [copied, setCopied] = useState(false);
  const guestUrl = `${window.location.origin}/guest/survey/${survey.guest_token}`;
  const responses = survey.responses_count ?? 0;
  const invited = survey.invited_count ?? Math.max(responses, 24);

  return (
    <div className="survey-hub-content">
      <SurveyHubHero
        title="Публикация и гостевая ссылка"
        description="После утверждения формируется уникальная ссылка. Анонимный режим и режим с подтверждением демонстрируются отдельно."
      />

      <section className="survey-hub-panel">
        <header>
          <div className="grow">
            <h3>Гостевая ссылка</h3>
            <p>Уникальная ссылка создана для конкретного опроса, проекта и автора.</p>
          </div>
          <span className="survey-hub-chip ok">Утверждено</span>
        </header>
        <div className="survey-hub-link">
          <code>{guestUrl}</code>
          <button
            type="button"
            className="survey-hub-btn"
            onClick={() => {
              navigator.clipboard.writeText(guestUrl);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }}
          >
            {copied ? 'Скопировано' : 'Копировать'}
          </button>
          <button type="button" className="survey-hub-btn primary" onClick={onOpenGuestAnonymous}>
            Открыть анонимно
          </button>
          <button type="button" className="survey-hub-btn gold" onClick={onOpenGuestVerified}>
            Открыть с подтверждением
          </button>
        </div>
      </section>

      <section className="survey-hub-panel">
        <header>
          <div className="grow">
            <h3>Изоляция и права</h3>
            <p>
              Гость получает только форму и брендинг. Без кабинетов, меню ролей, файлов и внутренних
              ссылок.
            </p>
          </div>
        </header>
        <div className="survey-hub-chiprow">
          <span className="survey-hub-chip ok">опрос: {survey.id}</span>
          <span className="survey-hub-chip">проект: PHD-2026-ADAPT</span>
          <span className="survey-hub-chip">автор: владелец системы</span>
          <span className="survey-hub-chip gold">ответы: только автор / проект</span>
        </div>
      </section>

      <section className="survey-hub-panel">
        <header>
          <div className="grow">
            <h3>Результаты исследования</h3>
            <p>Ответы привязаны к опросу, проекту и автору.</p>
          </div>
          <button type="button" className="survey-hub-btn" onClick={onOpenDashboard}>
            Открыть аналитику
          </button>
        </header>
        <div className="survey-hub-metrics">
          <div className="survey-hub-metric">
            <b>{responses}</b>
            <small>ответов</small>
          </div>
          <div className="survey-hub-metric">
            <b>{invited}</b>
            <small>приглашено</small>
          </div>
          <div className="survey-hub-metric">
            <b>{invited ? Math.round((responses / invited) * 100) : 0}%</b>
            <small>доля ответов</small>
          </div>
          <div className="survey-hub-metric">
            <b>CSV / XLSX</b>
            <small>выгрузка</small>
          </div>
        </div>
        <div className="survey-hub-actions">
          <button type="button" className="survey-hub-btn" onClick={onBack}>
            ← Назад
          </button>
          <button
            type="button"
            className="survey-hub-btn"
            onClick={() => window.open(researchToolsApi.getExportSurveyCsvUrl(survey.id), '_blank')}
          >
            Экспорт CSV
          </button>
        </div>
      </section>
    </div>
  );
};
